import { useState } from 'react';
import { useTranslation } from 'react-i18next';
import { SectionChapterTitleModal } from './SectionChapterTitleModal';

type TreeProps = {
  chapterId: number | undefined;
  productionId: number | undefined;
  title: string | undefined;
};
function SectionChapterMenuTitle({ chapterId, productionId, title }: TreeProps) {
  const { t } = useTranslation();
  const [displayModal, setDisplayModal] = useState(false);
  return (
    <>
      <li onClick={() => setDisplayModal(true)}>
        <i className="fa-solid fa-pen-to-square" />
        {t('タイトル変更')}
      </li>
      <SectionChapterTitleModal
        chapterId={Number(chapterId)}
        productionId={Number(productionId)}
        title={title}
        open={displayModal}
        onClose={() => setDisplayModal(false)}
      />
    </>
  );
}
export { SectionChapterMenuTitle };
